/**
 * Current legal document versions (client-side).
 * Must match the versions in convex/gdpr.ts and game/utils/legalVersions.js
 * Each version names one text, pinned by tests/unit/gdpr/legalVersions.test.js.
 */
const LEGAL_VERSIONS = {
  tos: "2026-10-03-v1",
  privacy: "2026-10-04-v1",
  marketing: "2026-06-15-v1",
  emailMarketing: "2026-09-18-v1",
  // The express-request text the store's upgrade dialog shows (the Stripe
  // checkout page carries the same version's wording for new purchases).
  purchaseConsent: "2026-10-03-v1",
};

export { LEGAL_VERSIONS };
